// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface V1OwnerReference
 */
export interface V1OwnerReference {
  /**
   * API version of the referent.
   * @type {string}
   * @memberof V1OwnerReference
   */
  apiVersion?: string;
  /**
   * If true, AND if the owner has the "foregroundDeletion" finalizer, then
   * the owner cannot be deleted from the key-value store until this
   * reference is removed.
   * See https://kubernetes.io/docs/concepts/architecture/garbage-collection/#foreground-deletion
   * for how the garbage collector interacts with this field and enforces the foreground deletion.
   * Defaults to false.
   * To set this field, a user needs "delete" permission of the owner,
   * otherwise 422 (Unprocessable Entity) will be returned.
   * +optional
   * @type {boolean}
   * @memberof V1OwnerReference
   */
  blockOwnerDeletion?: boolean;
  /**
   * If true, this reference points to the managing controller.
   * +optional
   * @type {boolean}
   * @memberof V1OwnerReference
   */
  controller?: boolean;
  /**
   * Kind of the referent.
   * More info: https://git.k8s.io/community/contributors/devel/sig-architecture/api-conventions.md#types-kinds
   * @type {string}
   * @memberof V1OwnerReference
   */
  kind?: string;
  /**
   * Name of the referent.
   * More info: https://kubernetes.io/docs/concepts/overview/working-with-objects/names#names
   * @type {string}
   * @memberof V1OwnerReference
   */
  name?: string;
  /**
   * UID of the referent.
   * More info: https://kubernetes.io/docs/concepts/overview/working-with-objects/names#uids
   * @type {string}
   * @memberof V1OwnerReference
   */
  uid?: string;
}

/**
 * Check if a given object implements the V1OwnerReference interface.
 */
export function instanceOfV1OwnerReference(
  value: object,
): value is V1OwnerReference {
  return true;
}

export function V1OwnerReferenceFromJSON(json: any): V1OwnerReference {
  return V1OwnerReferenceFromJSONTyped(json, false);
}

export function V1OwnerReferenceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1OwnerReference {
  if (json == null) {
    return json;
  }
  return {
    apiVersion: json['apiVersion'] == null ? undefined : json['apiVersion'],
    blockOwnerDeletion:
      json['blockOwnerDeletion'] == null
        ? undefined
        : json['blockOwnerDeletion'],
    controller: json['controller'] == null ? undefined : json['controller'],
    kind: json['kind'] == null ? undefined : json['kind'],
    name: json['name'] == null ? undefined : json['name'],
    uid: json['uid'] == null ? undefined : json['uid'],
  };
}

export function V1OwnerReferenceToJSON(json: any): V1OwnerReference {
  return V1OwnerReferenceToJSONTyped(json, false);
}

export function V1OwnerReferenceToJSONTyped(
  value?: V1OwnerReference | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    apiVersion: value['apiVersion'],
    blockOwnerDeletion: value['blockOwnerDeletion'],
    controller: value['controller'],
    kind: value['kind'],
    name: value['name'],
    uid: value['uid'],
  };
}
